export * from './directives/NgWidgetContainer';
export * from './directives/NgWidget';
export * from './components/NgWidgetPlaceholder';
export * from './interfaces/INgDraggableWidgetConfig';
export * from './modules/NgDraggableWidget.module';


// WEBPACK FOOTER //
// ./src/lib/ngx-draggable-widget/src/main.ts